import { render, staticRenderFns } from "./InvestmentAdvisoryList.vue?vue&type=template&id=512cf43b&"
import script from "./InvestmentAdvisoryList.vue?vue&type=script&lang=js&"
export * from "./InvestmentAdvisoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports